import React from 'react';
import { Box, Typography, Stack, Chip, Button } from '@mui/material';
import { ProcedureType } from '../../../../../../../services/ConfigurationService/types/procedureType';

interface SelectedProcedureCardProps {
    procedure: ProcedureType;
    onClear: () => void;
}

export const SelectedProcedureCard: React.FC<SelectedProcedureCardProps> = ({
    procedure,
    onClear
}) => {
    return (
        <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 1, border: '1px solid #e2e8f0' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                Selected Procedure:
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
                <Chip
                    label={procedure.codeType}
                    size="small"
                    sx={{ bgcolor: '#3b82f6', color: 'white' }}
                />
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {procedure.code}
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                    {procedure.description}
                </Typography>
                <Button
                    size="small"
                    onClick={onClear}
                    sx={{
                        color: '#64748b',
                        borderColor: '#e2e8f0',
                        '&:hover': {
                            backgroundColor: '#f8fafc',
                            borderColor: '#cbd5e1'
                        }
                    }}
                >
                    Change
                </Button>
            </Stack>
        </Box>
    );
};
